import {request} from "./request";
// 客户任务
// 客户任务列表
export function getCustomerTaskList(pagesize, page, title) {
    return request({
        url: '/hkt/customertask/get_customer_task_list',
        params: {
            pagesize,
            page,
            title
        }
    })
}
// 修改客户任务开关
export function changeCustomerTaskState(id, is_lock) {
    return request({
        url: '/hkt/customertask/change_customer_task_state',
        params: {
            id,
            is_lock
        }
    })
}
// 创建客户任务
export function addCustomerTask(title, user_member_id, content) {
    return request({
        url: '/hkt/customertask/add_customer_task',
        params: {
            title,
            user_member_id,
            content
        }
    })
}
// 删除客户任务
export function delCustomerTask(id) {
    return request({
        url: '/hkt/customertask/del_customer_task',
        params: {
            id
        }
    })
}
// 获取客户任务
export function getCustomerTask(id) {
    return request({
        url: '/hkt/customertask/get_customer_task',
        params: {
            id
        }
    })
}
// 修改客户任务
export function editCustomerTask(id, title, user_member_id, content) {
    return request({
        url: '/hkt/customertask/edit_customer_task',
        params: {
            id,
            title,
            user_member_id,
            content
        }
    })
}


// 客户群标签
// 客户群标签规则列表
export function getCustomerBaseTagRuleList(pagesize, page, tag_id, name) {
    return request({
        url: '/hkt/customerbasetagrule/get_customer_base_tag_rule_list',
        params: {
            pagesize,
            page,
            tag_id,
            name
        }
    })
}
// 添加客户群标签规则
export function addCustomerBaseTagRule(name, content, tag_id, chat_id) {
    return request({
        url: '/hkt/customerbasetagrule/add_customer_base_tag_rule',
        params: {
            name,
            content,
            tag_id,
            chat_id
        }
    })
}
// 删除客户群标签规则
export function delCustomerBaseTagRule(id) {
    return request({
        url: '/hkt/customerbasetagrule/del_customer_base_tag_rule',
        params: {
            id,
        }
    })
}
// 修改客户群标签规则状态
export function editCustomerBaseTagRuleState(id, state) {
    return request({
        url: '/hkt/customerbasetagrule/edit_customer_base_tag_rule_state',
        params: {
            id,
            state
        }
    })
}
// 客户群列表
export function getCustomerBaseList(pagesize, page, chat_name) {
    return request({
        url: '/hkt/customerbase/get_customer_base_list',
        params: {
            pagesize,
            page,
            chat_name
        }
    })
}
// 客户群标签 规则详情
export function getCustomerBaseTagRule(id) {
    return request({
        url: '/hkt/customerbasetagrule/get_customer_base_tag_rule',
        params: {
            id
        }
    })
}
// 客户群标签 规则客户列表
export function getCustomerBaseTagRecordList(id, pagesize, page, customer_name, chat_name, member_id, search_time, join_scene) {
    return request({
        url: '/hkt/customerbasetagrule/get_customer_base_tag_record_list',
        params: {
            id,
            pagesize,
            page,
            customer_name,
            chat_name,
            member_id,
            search_time,
            join_scene
        }
    })
}




// 分时段打标签
// 分时段打标签规则列表
export function getCustomerTagRuleList(pagesize, page, tag_id, name) {
    return request({
        url: '/hkt/customertagrule/get_customer_tag_rule_list',
        params: {
            pagesize,
            page,
            tag_id,
            name
        }
    })
}
// 分时段打标签 添加规则
export function addCustomerTagRule(name, content, tag_id, effective_member_id) {
    return request({
        url: '/hkt/customertagrule/add_customer_tag_rule',
        params: {
            name,
            content,
            tag_id,
            effective_member_id
        }
    })
}
// 分时段打标签 删除规则
export function delCustomerTagRule(id) {
    return request({
        url: '/hkt/customertagrule/del_customer_tag_rule',
        params: {
            id
        }
    })
}
// 分时段打标签 修改规则状态
export function editCustomerTagRuleState(id, state) {
    return request({
        url: '/hkt/customertagrule/edit_customer_tag_rule_state',
        params: {
            id,
            state
        }
    })
}
// 分时段打标签 获取规则详情
export function getCustomerTagRule(id) {
    return request({
        url: '/hkt/customertagrule/get_customer_tag_rule',
        params: {
            id
        }
    })
}
// 分时段打标签 获取规则客户列表
export function getCustomerTagRecordList(id, pagesize, page, customer_name, member_id, search_time, subrule_id) {
    return request({
        url: '/hkt/customertagrule/get_customer_tag_record_list',
        params: {
            id,
            pagesize,
            page,
            customer_name,
            member_id,
            search_time,
            subrule_id
        }
    })
}



// 沟通话术库
// 获取话术分组列表
export function getSpeechcraftLibraryGroupList() {
    return request({
        url: '/hkt/speechcraftlibrarygroup/get_speechcraft_library_group_list',
    })
}

// 获取子分组
export function getSpeechcraftLibrarySubGroup(group_id) {
    return request({
        url: '/hkt/speechcraftlibrarygroup/get_speechcraft_library_sub_group',
        params: {
            group_id
        }
    })
}

// 添加话术分组
export function addSpeechcraftLibraryGroup(name, sub_name) {
    return request({
        url: '/hkt/speechcraftlibrarygroup/add_speechcraft_library_group',
        params: {
            name,
            sub_name
        }
    })
}
// 编辑话术分组
export function editSpeechcraftLibraryGroup(group_id, name, edit_group_info, del_group_info, add_group_info) {
    return request({
        url: '/hkt/speechcraftlibrarygroup/edit_speechcraft_library_group',
        params: {
            group_id,
            name,
            edit_group_info,
            del_group_info,
            add_group_info
        }
    })
}
// 删除话术分组
export function delSpeechcraftLibraryGroup(group_id) {
    return request({
        url: '/hkt/speechcraftlibrarygroup/del_speechcraft_library_group',
        params: {
            group_id
        }
    })
}
// 获取话术列表
export function getSpeechcraftLibraryList(pagesize, page, content, group_id) {
    return request({
        url: '/hkt/speechcraftlibrary/get_speechcraft_library_list',
        params: {
            pagesize,
            page,
            content,
            group_id
        }
    })
}
// 添加话术
export function addSpeechcraftLibrary(title, group_id, content1, type) {
    return request({
        url: '/hkt/speechcraftlibrary/add_speechcraft_library',
        params: {
            title,
            group_id,
            content1,
            type
        }
    })
}
// 删除话术
export function delSpeechcraftLibrary(id) {
    return request({
        url: '/hkt/speechcraftlibrary/del_speechcraft_library',
        params: {
            id,
        }
    })
}
// 编辑话术
export function editSpeechcraftLibrary(id, title, group_id, content1, type) {
    return request({
        url: '/hkt/speechcraftlibrary/edit_speechcraft_library',
        params: {
            id,
            title,
            group_id,
            content1,
            type
        }
    })
}
// 导入话术
export function addBatchSpeechcraftLibrary(data) {
    return request({
        url: '/hkt/speechcraftlibrary/add_batch_speechcraft_library',
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data: data
    })
}

